'use client';
export {
  VisuallyHidden,
  //
  Root,
  //
  VISUALLY_HIDDEN_STYLES,
} from './visually-hidden';
export type { VisuallyHiddenProps } from './visually-hidden';
